export default "__VITE_ASSET__B5bB4lXZ__"